import { postUnauthRequest, putRequest, postRequest, getRequest } from "../../../../helpers/api";

import {config} from '../../../../helpers/constants'

var _URL = `${config.API_URL}/api/auth`;
var _URL_BASE = `${config.API_URL}/api`;

/**
 * @description Authentication API calls. 
 */
class AuthClass {

    /**
     * @description sign in user.
     * @param {email, password} payload 
     * @returns Promise
     */
    authSignIn(payload) {   
        return postUnauthRequest(`${_URL}/signin`, payload);
    }

    /**
     * @description Register a user.
     * @param {firstName, lastName, position, email, password} payload 
     * @returns Promise
     */
    authRegister(payload) {   
        return postUnauthRequest(`${_URL}/register`, payload);
    }

    /**
     * @description Change the logged in user's own password.
     * @param {{ currentPassword: string, password: string }} payload
     * @returns Promise
     */
    updateUser(payload) {   
        return putRequest(`${_URL}/users`, payload);
    }

    /**
     * @description Request a password reset email.
     * @param {{ email: string }} payload
     * @returns Promise
     */
    forgotPassword(payload) {
        return postUnauthRequest(`${_URL}/forgot-password`, payload);
    }

    /**
     * @description Set a new password using the token from the reset email.
     * @param {{ token: string, password: string }} payload
     * @returns Promise
     */
    resetPassword(payload) {
        return postUnauthRequest(`${_URL}/reset-password`, payload);
    }

    /**
     * @description submit comment
     * @param {user, comment, date} payload 
     * @returns Promise
     */
    submitComment(payload) {   
        return postRequest(`${_URL_BASE}/comments`, payload);
    }

    /**
     * @description api to get the status of user's profile
     */
    profileInfo() {
        return getRequest(`${_URL}/profile`)
    }
}

export default new AuthClass();